import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function CampaigncenterInfo(){
  const { campaigncenterObj} = useSelector((state)=>state.manufslice.campaigncenterDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ campaigncenterObj.businessid!==null && campaigncenterObj.businessid!==undefined?campaigncenterObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="title"  value={ campaigncenterObj.title!==null && campaigncenterObj.title!==undefined?campaigncenterObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Campaign Date" value={ campaigncenterObj.campaigndate!==null && campaigncenterObj.campaigndate!==undefined?campaigncenterObj.campaigndate.split('T')[0]:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Campaign Count"  value={ campaigncenterObj.campaigncount!==null && campaigncenterObj.campaigncount!==undefined?campaigncenterObj.campaigncount:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}